<div class="container-fluid">
  <div class="row">
    <div class="kt-widget filter">
      <div class="form-group m200 mr-5">
        <label for="">Pipeline</label>
        <select
          class="form-control"
          [(ngModel)]="filter.pipeline"
          (change)="getRecords()"
        >
          <ng-container *ngIf="pipelineSvc.pipelines$ | async as pipelines">
            <option *ngFor="let p of pipelines.data" [value]="p.id">
              {{ p.label }}
            </option>
          </ng-container>
        </select>
      </div>

      <div class="form-group">
        <label for="">Task Name</label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="filter.design_name"
          (keyup.enter)="getRecords(false, 1)"
        />
      </div>

      <div class="form-group">
        <label for="">Reference ID</label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="filter.id"
          (keyup.enter)="getRecords(false, 1)"
        />
      </div>

      <button class="btn btn-outline-info btn-sm m-1" (click)="resetFilters()">
        <i class="fas fa-eraser"></i> Reset Filters
      </button>

      <button
        (click)="showFilter = true"
        *ngIf="!showFilter"
        class="btn btn-info btn-sm m-1"
      >
        Show Advanced Filter
      </button>
      <button
        (click)="showFilter = false"
        *ngIf="showFilter"
        class="btn btn-info btn-sm m-1"
      >
        Hide Advanced Filter
      </button>
    </div>

    <div class="kt-widget filter row align-items-center" *ngIf="showFilter">
      <div class="form-group mw-200">
        <label for="">Assignee</label>
        <ng-select
          [items]="staffSvc.assignee$ | async"
          [multiple]="false"
          [closeOnSelect]="true"
          bindLabel="firstname"
          bindValue="id"
          [searchable]="true"
          [(ngModel)]="filter.assignee"
          [hideSelected]="true"
          (change)="getRecords()"
        >
          <ng-template ng-label-tmp let-item="item" let-clear="clear">
            <span class="ng-value-label">
              {{ item.firstname }} {{ item.lastname }}
            </span>
            <span
              class="ng-value-icon right"
              (click)="clear(item)"
              aria-hidden="true"
              >×</span
            >
          </ng-template>
          <ng-template
            ng-option-tmp
            let-item="item"
            let-index="index"
            let-search="searchTerm"
          >
            <div>{{ item.firstname }} {{ item.lastname }}</div>
          </ng-template>
        </ng-select>
      </div>

      <div class="form-group">
        <label for="">SKU / Product Name</label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="filter.sku"
          (keyup.enter)="getRecords(false, 1)"
        />
      </div>

      <div class="form-group">
        <label for="">Priority</label>
        <select
          type="text"
          class="form-control"
          [(ngModel)]="filter.design_priority"
          (change)="getRecords()"
        >
          <option value="">All</option>
          <option value="10">Low</option>
          <option value="20">Medium</option>
          <option value="30">High</option>
        </select>
      </div>

      <div class="form-group">
        <label for="">Tags</label>
        <ng-select
          [items]="tagSvc.formattedRecord$ | async"
          bindValue="id"
          [searchFn]="customTagsSearchFn"
          [(ngModel)]="filter.assigned_tags"
          (change)="getRecords()"
          multiple="true"
          [loading]="tagSvc.gettingRecords"
        >
          <ng-template ng-label-tmp let-item="item" let-clear="clear">
            <span
              class="ng-value-icon right"
              (click)="clear(item)"
              aria-hidden="true"
              >×</span
            >
            <span [innerHTML]="item.rawName" class="d-inline"></span>
          </ng-template>
          <ng-template
            ng-option-tmp
            let-item="item"
            let-index="index"
            let-search="searchTerm"
          >
            <h6 [innerHTML]="item.name"></h6>
          </ng-template>
        </ng-select>
      </div>

      <div class="form-group">
        <label for="">Category</label>
        <ng-select
          [items]="pcatService._productCategories | async"
          bindValue="id"
          bindLabel="product_category"
          [(ngModel)]="filter.category_id"
          (change)="getRecords()"
          multiple="true"
          [loading]="pcatService.gettingRecords"
        >
        </ng-select>
      </div>

      <div class="form-group">
        <label for="">Sub Category</label>
        <ng-select
          [items]="subcategorySvc._subCategories | async"
          bindValue="id"
          bindLabel="sub_category"
          [(ngModel)]="filter.subcategory_id"
          (change)="getRecords()"
          multiple="true"
          [loading]="subcategorySvc.gettingRecords"
        >
        </ng-select>
      </div>

      <!-- <div class="form-group">
          <label for="">Due Date</label>
          <input type="date" class="form-control" [(ngModel)]="filter.due_date" (keyup.enter)="getRecords()"
              (change)="getRecords()" />
      </div> -->

      <div class="form-group">
        <label for="">Due Date From</label>
        <input
          type="date"
          class="form-control"
          [(ngModel)]="filter.date_from"
          (change)="getRecords()"
        />
      </div>
      <div class="form-group">
        <label for="">Due Date To</label>
        <input
          type="date"
          class="form-control"
          [(ngModel)]="filter.date_to"
          (change)="getRecords()"
        />
      </div>
    </div>
  </div>
</div>

<div class="kt-widget filter row justify-content-end pt-2">
  <div class="form-group col-auto align-self-end">
    <button
      *ngIf="checkedCount > 0"
      (click)="updateSelected()"
      [disabled]="productDesignSvc.gettingRecords"
      class="btn btn-primary btn-sm"
      [ngClass]="{
        'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light':
          productDesignSvc.gettingRecords,
      }"
    >
      <i class="fas fa-save"></i>
      Bulk Update Selected ({{ checkedCount }})
    </button>
  </div>

  <div ngbDropdown class="d-inline-block" append-to="body" container="body">
    <button
      ngbDropdownToggle
      type="button"
      color="default"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
      class="btn btn-sm btn-secondary"
    >
      <i class="fa fa-cog"></i> Columns ({{ getColumnsCount() }})
    </button>
    <div ngbDropdownMenu aria-labelledby="action-button" class="columns-dropdown">
      <div *ngFor="let column of columns; let i = index">
        <label>
          <input
            type="checkbox"
            [checked]="column.show"
            (change)="updateTableColumns(i)"
          />
          {{ column.label }}
        </label>
      </div>
    </div>
  </div>

  <div class="form-group col-auto align-self-end">
    <button class="btn btn-info btn-sm ml-2" (click)="addToPipelines()">
      <i class="fas fa-plus"></i> Add selected to pipelines
    </button>
  </div>
</div>

<div class="overflow-auto">
  <table class="table table-striped table-hover">
    <thead>
      <tr>
        <th>
          <mat-checkbox
            color="primary"
            [(ngModel)]="checkedAll"
            (ngModelChange)="checkAll()"
          >
          </mat-checkbox>
        </th>
        <ng-container *ngFor="let column of columns">
          <ng-container *ngIf="column.show">
            <th *ngIf="!column.sortable">{{ column.label }}</th>
            <th *ngIf="column.sortable" (click)="setOrder(column.key)">
              {{ column.label }}
              <ng-container
                *ngTemplateOutlet="
                  sort;
                  context: { order: filter.order, field: column.key }
                "
              >
              </ng-container>
            </th>
          </ng-container>
        </ng-container>
        <th class="text-center">&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="productDesignSvc.gettingRecords">
        <td colspan="12" class="text-center">
          <br />
          <h6 [translate]="'GENERAL.GETTING_RECORDS'">
            <i class="fas fa-spinner fa-spin"></i> Getting records...
          </h6>
          <br />
        </td>
      </tr>
      <tr
        *ngIf="
          !productDesignSvc.gettingRecords &&
          productDesigns.data &&
          productDesigns.data.length == 0
        "
      >
        <td colspan="12" class="text-center">
          <br />
          <h6 class="text-warning">No record found.</h6>
          <br />
        </td>
      </tr>
      <tr *ngFor="let r of productDesigns.data; let i = index">
        <td>
          <mat-checkbox
            color="primary"
            [(ngModel)]="checked[r.id]"
            (ngModelChange)="countChecked()"
          >
          </mat-checkbox>
        </td>
        <td *ngIf="getColumnProperty('created_at').show">
          {{ r.created_at | date: 'mediumDate' }}

          <span
            class="text-danger"
            *ngIf="column_settings && column_settings.created_at"
          >
            <i>
              {{
                column_settings.created_at.is_required && !r.created_at
                  ? 'Required'
                  : ''
              }}
            </i>
          </span>
        </td>
        <td *ngIf="getColumnProperty('due_date').show">
          {{ r.due_date | date: 'mediumDate' }}

          <span
            class="text-danger"
            *ngIf="column_settings && column_settings.due_date"
          >
            <i>
              {{
                column_settings.due_date.is_required && !r.due_date
                  ? 'Required'
                  : ''
              }}
            </i>
          </span>
        </td>
        <td *ngIf="getColumnProperty('id').show">
          {{ r.id }}
          <span class="text-danger" *ngIf="column_settings && column_settings.id">
            <i>
              {{ column_settings.id.is_required && !r.id ? 'Required' : '' }}
            </i>
          </span>
        </td>
        <!-- <td *ngIf="getColumnProperty('reference_id').show">
            {{r.reference_id}}
        </td> -->
        <td *ngIf="getColumnProperty('design_name').show">
          <a
            (click)="showDetails(r, i)"
            class="link"
            routerLinkActive="routerkit-active"
          >
            <ng-container *ngIf="getDescriptionLength(r.design_name) <= 90">
              {{ r.design_name | striphtml }}
            </ng-container>
            <ng-container *ngIf="getDescriptionLength(r.design_name) > 90">
              <!-- {{ r.show_all ? (r.design_name) : (r.design_name | striphtml | excerpt: 90) }} -->
              <span [innerHTML]="r.design_name" *ngIf="r.show_all_title"></span>
              <span *ngIf="!r.show_all_title">{{
                r.design_name | excerpt: 90
              }}</span>
            </ng-container>
          </a>
          <ng-container *ngIf="getDescriptionLength(r.design_name) > 90">
            <span class="text-nowrap">
              [
              <a
                class="text-expand-link"
                (click)="r.show_all_title = !r.show_all_title"
                >{{ r.show_all_title ? 'show less' : 'show more' }}</a
              >
              ]
            </span>
          </ng-container>

          <span
            class="text-danger"
            *ngIf="column_settings && column_settings.design_name"
          >
            <i>
              {{
                column_settings.design_name.is_required && !r.design_name
                  ? 'Required'
                  : ''
              }}
            </i>
          </span>
        </td>
        <td *ngIf="getColumnProperty('description').show">
          <div class="text-excerpt">
            <ng-container *ngIf="getDescriptionLength(r.description) <= 90">
              {{ r.description | striphtml }}
            </ng-container>
            <ng-container *ngIf="getDescriptionLength(r.description) > 90">
              <!-- {{ r.show_all ? (r.description) : (r.description | striphtml | excerpt: 90) }} -->
              <span [innerHTML]="r.description" *ngIf="r.show_all"></span>
              <span *ngIf="!r.show_all">{{
                r.description | striphtml | excerpt: 90
              }}</span>
              <span class="text-nowrap">
                [
                <a class="text-expand-link" (click)="r.show_all = !r.show_all">{{
                  r.show_all ? 'show less' : 'show more'
                }}</a>
                ]
              </span>
            </ng-container>
          </div>

          <span
            class="text-danger"
            *ngIf="column_settings && column_settings.description"
          >
            <i>
              {{
                column_settings.description.is_required && !r.description
                  ? 'Required'
                  : ''
              }}
            </i>
          </span>
        </td>
        <td *ngIf="getColumnProperty('links').show" class="td-link">
          <div *ngIf="r.links && r.links.length > 0">
            <div *ngFor="let link of r.links; let i = index">
              <a
                *ngIf="i < 2"
                class="pb-1 link"
                target="_blank"
                [href]="link"
                [title]="link"
                >{{ link | excerpt: 70 }}</a
              >
              <ng-container *ngIf="r.links_show && r.links.length > 2">
                <a
                  *ngIf="i >= 2"
                  class="pb-1 link"
                  target="_blank"
                  [href]="link"
                  [title]="link"
                  >{{ link | excerpt: 70 }}</a
                >
              </ng-container>
            </div>
            <ng-container *ngIf="r.links.length > 2">
              [
              <a class="link" (click)="r.links_show = !r.links_show">{{
                r.links_show ? 'hide' : 'show all links'
              }}</a>
              ]
            </ng-container>
          </div>

          <span
            class="text-danger"
            *ngIf="column_settings && column_settings.links"
          >
            <i>
              {{
                column_settings.links.is_required &&
                (!r.links || (r.links && r.links.length === 0))
                  ? 'Required'
                  : ''
              }}
            </i>
          </span>
        </td>
        <td *ngIf="getColumnProperty('attachments').show">
          <div *ngIf="r.attachments && r.attachments.length > 0">
            <cnc-attachments-view
              [attachments]="r.attachments"
            ></cnc-attachments-view>
          </div>

          <span
            class="text-danger"
            *ngIf="column_settings && column_settings.attachments"
          >
            <i>
              {{
                column_settings.attachments.is_required &&
                (!r.attachments || (r.attachments && r.attachments.length === 0))
                  ? 'Required'
                  : ''
              }}
            </i>
          </span>
        </td>
        <td *ngIf="getColumnProperty('assignees').show">
          <a *ngFor="let u of r.assigned_users; let islast = last">
            <ng-container *ngIf="u.user">
              {{ u.user.firstname + ' ' + u.user.lastname }}{{ isLast ? '' : ', ' }}
            </ng-container>
          </a>

          <span
            class="text-danger"
            *ngIf="column_settings && column_settings.assignees"
          >
            <i>
              {{
                column_settings.assignees.is_required &&
                (!r.assigned_users ||
                  (r.assigned_users && r.assigned_users.length === 0))
                  ? 'Required'
                  : ''
              }}
            </i>
          </span>
        </td>
        <td *ngIf="getColumnProperty('pipeline').show" class="td-pipeline">
          <ng-container *ngIf="r.pipelines && r.pipelines.length">
            <tr>
              <th>Pipeline</th>
              <th>Stage</th>
              <!-- <th>Priority</th> -->
            </tr>
            <tr *ngFor="let p of r.pipelines" class="pipeline">
              <td *ngIf="p.pipeline">{{ p.pipeline.label }}</td>
              <td *ngIf="p.pipeline_stage">{{ p.pipeline_stage.stage }}</td>
              <!-- <td>{{ priority[p.priority] }}</td> -->
            </tr>
          </ng-container>

          <span
            class="text-danger"
            *ngIf="column_settings && column_settings.pipeline"
          >
            <i>
              {{
                column_settings.pipeline.is_required &&
                (!r.pipelines || (r.pipelines && r.pipelines.length === 0))
                  ? 'Required'
                  : ''
              }}
            </i>
          </span>
        </td>
        <td *ngIf="getColumnProperty('assigned_subtasks').show">
          <ng-container *ngIf="r.assigned_subtasks && r.assigned_subtasks.length">
            <a
              (click)="showDetails(r, i, 2)"
              class="link"
              routerLinkActive="routerkit-active"
            >
              {{ getSubtasksStatusCount(r.assigned_subtasks) }}
            </a>
          </ng-container>

          <span
            class="text-danger"
            *ngIf="column_settings && column_settings.assigned_subtasks"
          >
            <i>
              {{
                column_settings.assigned_subtasks.is_required &&
                (!r.assigned_subtasks ||
                  (r.assigned_subtasks && r.assigned_subtasks.length === 0))
                  ? 'Required'
                  : ''
              }}
            </i>
          </span>
        </td>
        <td class="text-right">
          <div ngbDropdown class="d-inline-block" append-to="body" container="body">
            <button
              ngbDropdownToggle
              mat-mini-fab
              type="button"
              color="default"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="flaticon-more-1"></i>
            </button>
            <div ngbDropdownMenu aria-labelledby="action-button">
              <button ngbDropdownItem (click)="addToPipeline(r)">
                <i class="fas fa-plus"></i> Add to Pipeline
              </button>
              <button ngbDropdownItem (click)="editdesign(r)">
                <i class="fas fa-edit"></i> Edit
              </button>
              <button
                *ngIf="abilityToDelete(r)"
                ngbDropdownItem
                (click)="deletedesign(r)"
              >
                <i class="fas fa-trash text-danger"></i> Delete
              </button>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<mat-paginator
  [length]="productDesigns.total"
  [pageSize]="productDesigns.per_page"
  [pageSizeOptions]="pageSizeOptions"
  (page)="getRecords($event)"
>
</mat-paginator>

<ng-template #sort let-order="order" let-field="field">
  <div class="pull-right sort">
    <i class="fas fa-sort" *ngIf="!field || !order || order.indexOf(field) < 0"></i>
    <i class="fas fa-sort-up" *ngIf="order == field"></i>
    <i class="fas fa-sort-down" *ngIf="order == '-' + field"></i>
  </div>
</ng-template>
